import styled from '@emotion/styled';

/** ETextPrimary is a element to  style text with the primary color of the application*/
export const ETextPrimary = styled.span`
  color: var(--color-core-primary);
`;
